module.exports = __webpack_public_path__ + "img/i-share-sms.625d1076.svg";